<script lang="ts">
	import { t } from 'svelte-i18n';
	import type { DecisionToolMarks } from '$lib/types/props';

	export let scores: DecisionToolMarks[];

	const getLabelByIndex = (index: number) => {
		switch (index) {
			case 0:
				return $t('decisionTool.details.salesRevenues');
			case 1:
				return $t('decisionTool.details.shareholderEquity');
			case 2:
				return $t('decisionTool.details.indebted');
			case 3:
				return $t('decisionTool.details.funds');
			case 4:
				return $t('decisionTool.details.bookingRatio');
			case 5:
				return $t('decisionTool.details.coverProductionCost');
			case 6:
				return $t('decisionTool.details.fundsSecurity');
			case 7:
				return $t('decisionTool.details.technicalSecurity');
			default:
				return null;
		}
	};
</script>

{#if scores.length === 8}
	<div>
		<div class="row font-light">
			<span class="font-bold">{$t('decisionTool.details.operatorRisk')}</span>
			<span>{$t('decisionTool.details.pointOfRisk')}</span>
		</div>

		<div class="details-bloc">
			{#each scores as score, i}
				{#if i < 4}
					<div class="row details-row">
						<span>{getLabelByIndex(i)}</span>
						<span class="font-bold text-decision-tool-{score}">{score}</span>
					</div>
				{/if}
			{/each}
		</div>

		<div class="row font-light">
			<span class="font-bold">{$t('decisionTool.details.programRisk')}</span>
			<span>{$t('decisionTool.details.pointOfRisk')}</span>
		</div>

		<div class="details-bloc">
			{#each scores as score, i}
				{#if i >= 4}
					<div class="row details-row">
						<span>{getLabelByIndex(i)}</span>
						<span class="font-bold text-decision-tool-{score}">{score}</span>
					</div>
				{/if}
			{/each}
		</div>
	</div>
{:else}
	<p class="text-danger">Mark array must contain 8 values</p>
{/if}

<style lang="postcss">
	.row {
		@apply flex justify-between items-center px-4 py-3 text-xl;
	}

	.details-bloc {
		@apply border border-grey-light rounded-lg;
	}

	.details-row {
		@apply border-b border-grey-light last:border-b-0;
	}
</style>
